export const REQUEST_ID_HEADER = 'X-Request-ID'

export const createRequestID = (): string => {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID()
  }
  return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}`
}

export const getRequestID = (value: any): string => {
  const responseID = value?.response?.headers?.['x-request-id'] || value?.headers?.['x-request-id']
  const requestID = value?.config?.headers?.[REQUEST_ID_HEADER] || value?.headers?.[REQUEST_ID_HEADER]
  return String(responseID || requestID || '')
}

export const requestLogContext = (value: any): { status?: number; requestId: string } => ({
  status: typeof value?.response?.status === 'number' ? value.response.status : undefined,
  requestId: getRequestID(value)
})

export const withRequestID = (message: string, requestID: string): string => {
  return requestID ? `${message}（追蹤碼：${requestID}）` : message
}
